import React, { useEffect } from 'react'
import { Alert } from '@indeed/ifl-components'
import { useFlexFlagIsOn } from '@indeed/flex-feature-flags'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { fetchShiftIssues } from 'syft-acp-core/store/shift-issues/actions'
import { selectShiftIssues } from 'syft-acp-core/store/shift-issues/selectors'
import { ShiftIssue } from 'syft-acp-core/store/shift-issues/types'
import { ShiftIssuesBannerProps } from './ShiftIssuesBanner.types'

export const storeConnector = connect(
  (state, { shiftID }: { shiftID: number }) => ({
    issues: selectShiftIssues(state, shiftID),
  }),
  dispatch => ({
    actions: bindActionCreators({ fetchShiftIssues }, dispatch),
  }),
)

// PENDING issues have no permalink because the Slack thread cap held the post back. They are
// still real issues, so they render the same minus the link.
const IssueExplanation = ({ issue }: { issue: ShiftIssue }) => (
  <>
    {issue.explanation}
    {issue.slack_permalink && (
      <>
        {' '}
        <a href={issue.slack_permalink} target="_blank" rel="noopener noreferrer">
          View in Slack
        </a>
      </>
    )}
  </>
)

export const ShiftIssuesBanner = ({ shiftID, issues, actions }: ShiftIssuesBannerProps) => {
  const isEnabled = useFlexFlagIsOn('stssre_2654_shift_issues_banner')

  // Gating the fetch as well as the render keeps a disabled banner off the network entirely.
  useEffect(() => {
    if (isEnabled && shiftID) {
      actions.fetchShiftIssues(shiftID)
    }
  }, [isEnabled, shiftID, actions])

  if (!isEnabled) {
    return null
  }

  // An empty list is not a clean bill of health: it also covers shifts outside every check's
  // cohort, beyond the alert window, capped, or never assessed. The API cannot tell those
  // apart, so render nothing rather than imply the shift is fine.
  if (!issues.length) {
    return null
  }

  return (
    <Alert status="warning">
      {issues.map(issue => (
        <p key={issue.check}>
          <strong>{issue.title}</strong>
          <br />
          <IssueExplanation issue={issue} />
        </p>
      ))}
    </Alert>
  )
}

export default storeConnector(ShiftIssuesBanner)
